module.exports = __webpack_public_path__ + "img/制御工学5_6_2.93f6fa4c.png";